/**
 * React binding for JuiceService. Optional — everything falls back to the
 * shared `juice` singleton, so primitives work in any tree.
 */

import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { JuiceService } from "./service.js";
import { juice } from "./service.js";

const JuiceContext = createContext<JuiceService | null>(null);

export interface JuiceProviderProps {
  service: JuiceService;
  children?: ReactNode;
}

export function JuiceProvider({ service, children }: JuiceProviderProps) {
  return <JuiceContext.Provider value={service}>{children}</JuiceContext.Provider>;
}

/** The ambient JuiceService — context value or the shared singleton. */
export function useJuiceService(): JuiceService {
  return useContext(JuiceContext) ?? juice;
}
